<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <div class="img">
      <div class="bulle">
        <div class="cadre">
          <h3>Daria</h3>
          <audio controls>
            <source src="https://cdn.exploreve.fr/content/voix/daria_installcamp.mp3" type="audio/mpeg" />
          </audio>
          <p>
            Si tu ne peux pas écouter,
            <a
              class="next"
              target="_blank"
              href="https://cdn.exploreve.fr/content/transcriptions/daria_installation_du_camp.pdf"
              >clique ici</a
            >
          </p>
        </div>
      </div>
      <div class="daria">
        <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt />
      </div>
      <div class="support"></div>
    </div>
    <NextBtn class="send" @click="sendDraw" url="/immersion01/8" text="Envoie ton camp !" />

    <div class="nuage n01"></div>
    <div class="nuage n02"></div>
    <div class="nuage n03"></div>
  </div>
</template>
<script>
import NextBtn from "../NextButton";

export default {
  methods: {
    sendDraw() {
      this.$emit("send");
    }
  },
  components: { NextBtn }
};
</script>
<style scoped lang="scss">
.img {
  position: absolute;
  top: 20%;
  left: 10%;
  z-index: 10;
}

.bulle {
  position: absolute;
  top: -8vh;
  left: 40px;
  z-index: 10;
}

.cadre {
  position: absolute;
  background-color: white;
  width: 350px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 35%;
  width: 0;
  height: 0;
  transform: rotate(90deg);
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 60px solid white;
}

.daria {
  position: absolute;
  top: 18vh;
  left: 3vw;
  img {
    height: 40vh;
  }
  z-index: 5;
}

.support {
  position: absolute;
  background-color: $light;
  top: 51vh;
  height: 15vh;
  width: 38vh;
  -webkit-border-radius: 19vh / 8vh;
  -moz-border-radius: 19vh / 8vh;
  border-radius: 19vh / 8vh;
}

.nuage {
  position: relative;
  background-color: $light;
  opacity: 0.7;
}

.n01 {
  top: 70vh;
  left: 20vw;
  width: 300px;
  height: 80px;
  border-radius: 60px;
  z-index: 0;
}

.n02 {
  top: 50vh;
  left: 30vw;
  width: 197px;
  height: 33px;
  border-radius: 15px;
  z-index: 10;
}

.n03 {
  top: 35%;
  left: -80px;
  width: 641px;
  height: 145px;
  border-radius: 72px;
  z-index: 0;
}

.send {
  position: absolute;
  bottom: 5%;
  left: 10%;
}
</style>
